<!-- PC端 -->
<template>
  <div class="webPages">
    <!-- 导航栏 -->
    <nav-header @gotoDiv="gotoDiv"></nav-header>
    <!-- 大图 -->
    <section>
      <div class="bigBgBox" id="header">
        <div class="leftBox">
          <div class="imgTxtBox">
            <div class="imgTxtLeft" id="imgTxtLeft">
              <img src="../assets/web_txt1.png" alt="7动" />
            </div>
            <div class="imgTxtRight" id="imgTxtRight">
              <img src="../assets/web_txt2.png" alt="7动" />
            </div>
          </div>
        </div>
        <div class="rightBox">
          <img src="../assets/web_bg1.png" alt="凯格尔运动" />
          <transition name="fades">
            <div class="bigSpan" v-if="animate">
              全球500多万盆友的共同选择 有健康 才有未来
            </div>
          </transition>
        </div>
        <div style="clear: both"></div>
      </div>
    </section>
    <!-- 教学视频 -->
    <div id="video"></div>
    <section>
      <div class="titleBox">
        <div class="bigTitle">教学视频</div>
        <div class="titleTips">INSTRUCTIONAL VIDEO</div>
      </div>
      <!-- 单个视频 -->
      <div class="oneVideoBox" v-if="videoLenght < 2">
        <div class="videoBoxShow">
          <video id="videoOne" :src="playOne" @click="stopVideoPlay"></video>
          <img :src="poster" id="videoOneCover" lazy="loaded" alt="7动视频" />
          <div href="javascript:;" id="pauseVideo" style="display: none">
            <img src="../assets/pause.png" alt="7动视频" />
          </div>
          <div id="videoBtnPlay" href="javascript:;" @click="playVideoItem">
            <img src="../assets/play.png" alt="7动视频" />
          </div>
        </div>
        <div class="borderBox"></div>
      </div>
      <!-- 多视频 -->
      <div v-if="videoLenght > 1">
        <!-- 按钮 -->
        <div class="nextPreBtn" v-if="videoLenght > 4">
          <div class="preBtn" @click="preBtn()">
            <van-icon name="arrow-left" />
          </div>
          <div class="nextBtn" @click="nextBtn()">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="videoBox wrapper" ref="wrapper" id="videoBox">
          <div class="scollBox" ref="cont" id="scollBox">
            <div class="videoPlayOne" v-for="(item, index) in videoItem" :key="index">
              <div class="remakeImgBox" @click="playVideo(item.childplanRemark)">
                <img :src="item.remark" alt="7动视频" />
              </div>
              <div class="videoImg" @click="playVideo(item.childplanRemark)">
                <van-icon name="play-circle" />
              </div>
              <div class="videoName">{{ item.childplanName }}</div>
              <div class="videoTips">改善体态 强化力量</div>
            </div>
          </div>

          <div style="clear: both"></div>
        </div>
      </div>
    </section>
    <!-- 定制计划 -->
    <div style="height: 0px" id="plan"></div>
    <section>
      <div class="titleBox">
        <div class="bigTitle">定制计划</div>
        <div class="titleTips">CUSTOM PLAN</div>
      </div>
      <div class="planBox">
        <van-overlay :show="bigCodeShow" @click="bigCodeShow = false" class="boxWrapperBig">
          <div class="wrapperBig" @click.stop>
            <div class="bigCodeShow">
              <img src="../assets/code.png" alt="7动二维码" />
              <span>想要了解更多，请扫码下载7动APP！</span>
            </div>
          </div>
        </van-overlay>

        <div class="planLeft">
          <img src="../assets/plan2.png" alt="7动运动" />
        </div>
        <div class="planRight">
          <img src="../assets/holdPhone.png" alt="7动粉丝" />
        </div>
        <!-- <div class="testBtn" @click="bigCodeShow = true">了解更多</div> -->
        <div class="testBtn" @click="toTest()">了解更多</div>
        <div style="clear: both"></div>
      </div>
    </section>
    <!-- 粉丝 -->
    <div id="appBox"></div>
    <section>
      <div class="fansBgBox">
        <div class="fansBoxTop">
          <div class="leftFansBox">
            <div class="fansTxt">
              <div class="fansTxtOne">“</div>
              <div class="fansTxtTwo">此刻， 在7动运动</div>
              <div class="fansTxtThree">
                每分每秒，都有来自世界的7友与你一同锻炼盆底肌！
              </div>
            </div>
          </div>
          <div class="rightFansBox">
            <div class="fansListBox">
              <div class="listFlex">
                <!-- <van-swipe
                  id="van-swipe"
                  autoplay="2000"
                  style="height:80px"
                  :show-indicators="false"
                  vertical
                >
                  <van-swipe-item
                    style="height:80px"
                    v-for="(item,index) in arrOne"
                    :key="index"
                    class="fansOne"
                  >
                    <div class="fansImg">
                      <img :src="item.avatar" alt="7动粉丝" />
                    </div>
                    <div class="fansMsgBox">
                      <div class="fansName">{{item.nickName}}</div>
                      <div class="fansTips">
                        已经坚持锻炼
                        <span>{{Math.ceil(item.totalTime/60)}}</span>分钟
                      </div>
                    </div>
                  </van-swipe-item>
                </van-swipe>-->
                <!-- 循环用户 -->
                <div id="review_box">
                  <ul id="comment1">
                    <li v-for="(item, index) in arrOne" :key="index">
                      <div class="fansImg">
                        <img :src="item.avatar" alt="7动粉丝" />
                      </div>
                      <div class="fansMsgBox">
                        <div class="fansName">{{ item.nickName }}</div>
                        <div class="fansTips">
                          已经坚持锻炼
                          <span>{{ Math.ceil(item.totalTime / 60) }}</span>分钟
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul id="comment2"></ul>
                </div>
              </div>
              <div class="listFlex">
                <div id="review_boxC">
                  <ul id="comment1C">
                    <li v-for="(item, index) in arrTwo" :key="index">
                      <div class="fansImg">
                        <img :src="item.avatar" alt="7动粉丝" />
                      </div>
                      <div class="fansMsgBox">
                        <div class="fansName">{{ item.nickName }}</div>
                        <div class="fansTips">
                          已经坚持锻炼
                          <span>{{ Math.ceil(item.totalTime / 60) }}</span>分钟
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul id="comment2C"></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fansBoxBottom">
          <div class="codeDownBox">
            <div class="codeImg">
              <div class="downAppCode">
                <img src="../assets/code.png" alt="7动二维码" />
              </div>
              <div class="downAppTips">扫码下载APP</div>
            </div>
            <div class="downAppBox">
              <div class="downAppBtn">
                <div class="downAppImg">
                  <div class="wechat-dw">
                    <img src="../assets/androDown.png" alt="7动安卓版" />
                  </div>
                  <a href="https://pc7dong.com/file/app/android.apk">
                    <img src="../assets/downAnd.png" alt="7动安卓版" />
                  </a>
                </div>
                <div class="downAppImg">
                  <div class="wechat-dw">
                    <img src="../assets/iosDown.png" alt="7动苹果版" />
                  </div>
                  <a href="https://itunes.apple.com/cn/app/id1439306852">
                    <img src="../assets/ios.png" alt="7动苹果版" />
                  </a>
                </div>
                <div class="downAppImg">
                  <div class="wechat-dw">
                    <img src="../assets/tvDown.png" alt="7动TV版" />
                  </div>
                  <a href="https://pc7dong.com/file/app/guangWangTV.apk">
                    <img src="../assets/tv.png" alt="7动TV版" />
                  </a>
                </div>
              </div>
              <div class="downTips">适用于Apple，Android以及TV端。</div>
            </div>
          </div>
        </div>
        <div class="fansAppBigImg">
          <img src="../assets/twoPhone.png" alt="7动介绍" />
        </div>
      </div>
    </section>
    <!-- <div class="titleBox"></div> -->
    <!--  社区交流 -->
    <!-- <div id="community"></div>
    <section>
      <div class="titleBox" id="community">
        <div class="bigTitle">社区交流</div>
        <div class="titleTips">CUSTOM PLAN</div>
      </div>
      <div class="communityBox">
        <div class="communityTitle">超70万平台用户进行互动和男女问答</div>
        <div class="commMsgBox">
          <div
            class="commMsgOne"
            v-for="(item, index) in communityItem"
            :key="index"
            :id="'commMsgOne' + index"
          >
            <div class="grayCircle"></div>
            {{ item.title }}
          </div>
        </div>
      </div>
    </section> -->

    <!-- 学院视频 -->
    <!-- <section>
      <div class="titleBox" id="community">
        <div class="bigTitle">学院视频</div>
        <div class="titleTips">COLLEGE VIDEO</div>
      </div>
      <div class="collegeBox">
        <div class="videoPlayOne" v-for="(item, index) in videoCollege" :key="index">
          <div class="remakeImgBox newBox" @click="playVideo(item.video)">
            <img :src="item.imgUrl" alt="7动视频" />
          </div>
          <div class="videoImg newBox" @click="playVideo(item.video)">
            <van-icon name="play-circle" />
            <div class="videoTitle">{{ item.courseTitle }}</div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="moreVid">
        <div class="showMoreCord">
          <div class="codeImgBox"><img src="../assets/code.png" alt="" /></div>
          <div class="codeTxt">扫码下载APP</div>
        </div>
        查看更多视频
      </div>
    </section> -->

    <!-- 战略合作 -->
    <div id="partner"></div>
    <section>
      <div class="titleBox">
        <div class="bigTitle">战略合作</div>
        <div class="titleTips">COOPERATION</div>
      </div>
      <div class="partnerTitle">我们的每一步，都能使你变得更优秀</div>
      <div class="partnerBox">
        <div class="partnerImg">
          <img :src="bg3Img" @error="imgError(bg3Img)" alt="合作伙伴" />
        </div>
      </div>
    </section>

    <!-- 页脚菜单 -->
    <section id="footer">
      <div class="itemTabBox">
        <div class="itemTab">
          <div class="itemFlex">
            <div class="itemTabName">
              <a href="http://pc7dong.com/share/YHXY.html">用户协议</a>
            </div>
            <div class="itemTabName">
              <a href="http://pc7dong.com/share/YSXY.html">隐私政策</a>
            </div>
            <!-- <div class="itemTabName">
              <router-link to='/webAbout'><a href="javascript:;">关于我们</a></router-link>
            </div>-->
          </div>
          <div class="itemFlex">
            <!-- <div class="itemTabName">
              <a href="http://pc7dong.com/share/SQGY.html">社区公约</a>
            </div>
            <div class="itemTabName">
              <a href="http://pc7dong.com/share/SQGF.html">社区规范</a>
            </div>-->
            <div class="itemTabName">
              <router-link to="/webAboutUser">
                <a href="javascript:;">关于我们</a>
              </router-link>
            </div>
            <div class="itemTabName">
              <router-link to="/webContact">
                <a href="javascript:;">联系我们</a>
              </router-link>
            </div>
          </div>
        </div>
        <div class="itemImgBox">
          <div class="itemImg">
            <div class="itemImgIcon">
              <a href="https://weibo.com/u/6632173143">
                <img src="../assets/weibo.png" alt="7动官方微博" />
              </a>
              <div class="wechat-qr">
                <img src="../assets/weibolink.png" alt="7动官方微博" />
              </div>
            </div>
            <div class="itemImgTxt">7动官方微博</div>
          </div>
          <div class="itemImg">
            <div class="itemImgIcon">
              <img src="../assets/weixi.png" alt="7动男版微信群" />
              <div class="wechat-qr">
                <img src="../assets/man.png" alt="7动男版微信群" />
              </div>
            </div>
            <div class="itemImgTxt">男神专属</div>
          </div>
          <div class="itemImg">
            <div class="itemImgIcon">
              <img src="../assets/weixi.png" alt="7动女版微信群" />
              <div class="wechat-qr">
                <img src="../assets/gril.png" alt="7动女版微信群" />
              </div>
            </div>
            <div class="itemImgTxt">女神专属</div>
          </div>
        </div>
      </div>
    </section>
    <!-- 页脚 -->
    <nav-footer></nav-footer>
    <!-- 视频播放 -->
    <video-player v-show="isPlay" class="video-player vjs-custom-skin videoFloat" ref="videoPlayer" :playsinline="true"
      :options="playerOptions"></video-player>
    <div class="videoBgBox" v-show="isPlay" @click="stopPlay()">
      <div class="closeVideo">关闭</div>
    </div>

    <div style="display: none" id="statistics"></div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import BScroll from "better-scroll";
import NavFooter from "@/web/common/footer.vue";
import NavHeader from "@/web/common/header.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    videoPlayer,
    NavFooter,
    NavHeader,
  },
  data() {
    //这里存放数据
    return {
      animate: false,
      bg3Img: "",
      fansHeight: "",
      bigCodeShow: false,
      isPlay: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        // poster: "../assets/web_logo.png", //你的封面地址

        // width: document.documentElement.clientWidth,
        // notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      videoItem: [],
      videoCollege: [],
      arrOne: [],
      arrTwo: [],
      communityItem: [],
      videoLenght: 10, //视频数据长度
      playOne: [], //第一个视频的地址
      poster: "./static/video.png",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toTest() {
      window.location.href =
        "https://pc7dong.com/share/OfficialWebsite/index.html";
    },
    // 播放一个视频
    playVideoItem() {
      var video = document.getElementById("videoOne");
      var play = document.getElementById("videoBtnPlay");
      console.log("play", play);
      var cover = document.getElementById("videoOneCover");
      cover.style.zIndex = -1;
      play.style.zIndex = 3;
      video.style.zIndex = 4;
      video.play();
    },
    // 停止播放
    stopVideoPlay() {
      var video = document.getElementById("videoOne");
      var play = document.getElementById("videoBtnPlay");
      play.style.zIndex = 5;
      video.style.zIndex = 4;
      video.pause();
    },
    gotoDiv(str) {
      // console.log("跳转", str);
      document.getElementById(str).scrollIntoView(false);
      document.getElementById(str).scrollIntoView({ block: "start" });

      // document
      //   .getElementById(str)
      //   .scrollIntoView({
      //     behavior: "smooth",
      //     block: "start",
      //     inline: "nearest",
      //   });
    },

    init() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/back/user/coreTrainingVideoList")
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 0) {
            this.videoItem = res.data.data.list;
            // this.videoItem = this.videoItem.slice(0,5)
            // this.videoLenght = 1;
            this.videoLenght = this.videoItem.length;
            if (this.videoLenght == 1) {
              this.playOne = this.videoItem[0].childplanRemark;
              this.poster = this.videoItem[0].remark;
              // this.playVideoOne(this.playOne);
            }
            if (this.videoItem.length <= 5) {
              let ele = document.getElementById("scollBox");
              ele.style.height = "auto";
              let ele2 = document.getElementById("videoBox");
              ele2.style.height = "auto";
            }
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getCollege() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/api/course/selectOfficialCourseList")
        .then((res) => {
          if (res.data.code == 0) {
            this.videoCollege = res.data.data.lists;
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取粉丝
    getFans() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/back/user/userList")
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 0) {
            let fansArr = res.data.data.list;
            let arr = fansArr;
            this.arrOne = arr.slice(0, fansArr.length / 2);
            // console.log(JSON.stringify(arrOne));
            this.arrTwo = arr.slice(fansArr.length / 2);
            // console.log(JSON.stringify(arrTwo));
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取社区信息
    getCommunity() {
      //获取数据
      this.axios
        .get(this.ROOT + "/seveng/back/user/consultationList")
        .then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 0) {
            this.communityItem = res.data.data.list;
            // 随机生成位置
            // console.log(this.communityItem.length);
          } else {
            alert("错误");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    playVideoOne(url) {
      this.playerOptionsOne.sources = [
        {
          src: url, // 路径
          type: "video/mp4", // 类型
        },
      ];
      // this.playerOptions.poster = page;
    },
    playVideo(url) {
      this.isPlay = true;
      this.playerOptions.sources = [
        {
          src: url, // 路径
          type: "video/mp4", // 类型
        },
      ];
      // this.playerOptions.poster = page;
    },
    stopPlay() {
      this.isPlay = false;
      this.playerOptions.sources = [""];
    },
    verScroll() {
      // let width = this.videoItem.length * 380; // 动态计算出滚动区域的大小，前面已经说过了，产生滚动的原因是滚动区域宽度大于父盒子宽度
      let width = 6 * 380;
      this.$refs.cont.style.width = width + "px"; // 修改滚动区域的宽度
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.wrapper, {
            startX: 0, // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: "vertical",
          });
        } else {
          this.scroll.refresh(); //如果dom结构发生改变调用该方法
        }
      });
    },
    preBtn() {
      let ele = document.getElementById("scollBox");
      let str = ele.style.transform;

      if (str == "") {
      } else {
        let index = str.substr(0, str.indexOf("(") + 1);

        let num = str.substr(str.indexOf("(") + 1);
        let strNum = num.substr(0, num.indexOf("p"));

        let pop = str.substr(str.indexOf("p"));
        let numPx = parseInt(strNum) - 380;
        if (numPx < 380) {
          ele.style.transform = "translate(0px, 0px) scale(1) translateZ(0px)";
        } else {
          ele.style.transform = index + numPx + pop;
        }
      }
    },
    nextBtn() {
      let ele = document.getElementById("scollBox");
      let str = ele.style.transform;

      if (str != "") {
        let index = str.substr(0, str.indexOf("(") + 1);

        let num = str.substr(str.indexOf("(") + 1);
        let strNum = num.substr(0, num.indexOf("p"));

        let pop = str.substr(str.indexOf("p"));
        let numPx = parseInt(strNum) + -380;
        if (numPx < -757) {
          ele.style.transform =
            "translate(-757px, 0px) scale(1) translateZ(0px)";
        } else {
          ele.style.transform = index + numPx + pop;
        }
      } else {
        ele.style.transform = "translate(-380px, 0px) scale(1) translateZ(0px)";
        ele.style.transition = "500ms";
      }
    },
    // changeClass() {
    //   let ele = document.getElementById("van-swipe");
    //   let ele2 = document.getElementById("van-swipe2");
    //   let windowWeight = parseInt(document.body.clientWidth);
    //   let allFansOne = document.querySelectorAll(".fansOne");
    //   // console.log(windowWeight);
    //   // console.log(allFansOne);
    //   allFansOne.forEach((item, index) => {
    //     if (windowWeight > 1439) {
    //       item.style.height = "80px";
    //     }
    //     if (windowWeight < 1439 && 1024 < windowWeight) {
    //       item.style.height = "40px";
    //     }
    //     if (windowWeight < 1023 && 768 < windowWeight) {
    //       item.style.height = "40px";
    //     }
    //   });
    //   if (windowWeight > 1439) {
    //     ele.style.height = "320px";
    //     ele2.style.height = "320px";
    //     // console.log("小");
    //   }
    //   if (windowWeight < 1439 && 1024 < windowWeight) {
    //     ele.style.height = "160px";
    //     ele2.style.height = "160px";
    //     // console.log("中");
    //   }
    //   if (windowWeight < 1023 && 768 < windowWeight) {
    //     ele.style.height = "160px";
    //     ele2.style.height = "160px";
    //     // console.log("大");
    //   }
    // },
    imgError(bg3Img) {
      this.bg3Img = require("../assets/bg3.png");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.init();
    this.getFans();
    this.getCommunity();
    this.getCollege();
    // setTimeout(()=>{
    //   this.playVideoOne(this.playOne);
    // },1000)
    if (this.videoLenght > 1) {
      this.verScroll();
      // this.$nextTick(() => {
      //   let timer = setTimeout(() => {
      //     if (timer) {
      //       clearTimeout(timer);
      //       this.verScroll();
      //     }
      //   }, 1000);
      // });
    }
    let imgTxtLeft = document.getElementById("imgTxtLeft");
    imgTxtLeft.className = "imgTxtLeft moveToRight";
    let imgTxtRight = document.getElementById("imgTxtRight");
    imgTxtRight.className = "imgTxtRight moveToLeft";
    // let timer = setTimeout(() => {
    //   this.changeClass();
    // }, 1000);
    // setTimeout(() => {
    //   let arr = this.communityItem;
    //   // let newArr = arr.slice(0,arr.length/2);
    //   arr.forEach((item, index) => {
    //     let dom = document.getElementById("commMsgOne" + index);
    //     let randTop = Math.floor(Math.random() * (90 - 1) + 1);
    //     let randLeft = Math.floor(Math.random() * (90 - 1) + 1);
    //     dom.style.top = randTop + "%";
    //     dom.style.left = randLeft + "%";
    //   });
    // }, 1000);
    // setInterval(() => {
    //   setTimeout(() => {
    //     let arr = this.communityItem;
    //     // let newArr = arr.slice(0,arr.length/2);
    //     arr.forEach((item, index) => {
    //       let dom = document.getElementById("commMsgOne" + index);
    //       let randTop = Math.floor(Math.random() * (90 - 1) + 1);
    //       let randLeft = Math.floor(Math.random() * (90 - 1) + 1);
    //       dom.style.top = randTop + "%";
    //       dom.style.left = randLeft + "%";
    //       dom.style.transition = "1s";
    //     });
    //   }, 5000);
    // }, 3000);
    let id = this.$route.query.id;
    var div = document.getElementById(id);
    if (div) {
      setTimeout(function () {
        div.scrollIntoView();
        roll(50);
      }, 500);
    }

    //声明的DOM对象为全局
    var ul1 = document.getElementById("comment1");
    var ul2 = document.getElementById("comment2");
    var ulbox = document.getElementById("review_box");
    var ul1C = document.getElementById("comment1C");
    var ul2C = document.getElementById("comment2C");
    var ulboxC = document.getElementById("review_boxC");

    setTimeout(() => {
      window.onload = roll(50);
    }, 1000);

    function roll(t) {
      ul2.innerHTML = ul1.innerHTML;
      ul2C.innerHTML = ul1C.innerHTML;
      ulbox.scrollTop = 0; // 开始无滚动时设为0
      ulboxC.scrollTop = 0; // 开始无滚动时设为0
      var timerC = setInterval(rollStart, t); // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
      // 鼠标移入div时暂停滚动
      ulbox.onmouseover = function () {
        clearInterval(timerC);
      };
      ulboxC.onmouseover = function () {
        clearInterval(timerC);
      };
      // 鼠标移出div后继续滚动
      ulbox.onmouseout = function () {
        timerC = setInterval(rollStart, t);
      };
      ulboxC.onmouseout = function () {
        timerC = setInterval(rollStart, t);
      };
    }
    // 开始滚动函数
    function rollStart() {
      // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
      if (
        ulbox.scrollTop >= ul1.scrollHeight ||
        ulboxC.scrollTop >= ul1C.scrollHeight
      ) {
        ulbox.scrollTop = 0;
        ulboxC.scrollTop = 0;
      } else {
        ulbox.scrollTop++;
        ulboxC.scrollTop++;
      }
    }
    this.animate = true;
    // 滚动暂停视频
    let that = this;
    window.addEventListener("scroll", () => {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 1400) {
        that.stopVideoPlay()
      }
    });
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@keyframes anBox {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

#review_box,
#review_boxC {
  // width: 100px;
  height: 250px;
  /* 必须 */
  overflow: hidden;
  /* 必须 */
  margin: 50px auto;
  // text-align: center;
}

#review_box ul,
#review_boxC ul {
  list-style: none;
}

#review_box ul>li {
  display: flex;
  margin-bottom: 20px;
}

#review_boxC ul>li {
  display: flex;
  margin-bottom: 20px;
}

.loadingIcon {
  animation: rotating-data-v-1348df5c 1.2s linear infinite;
  width: 10%;
  position: fixed;
  top: 45%;
  left: 45%;
}

/* 旋转 */
@keyframes rotating {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.bigCodeShow {
  width: 300px;
}

.bigCodeShow span {
  color: #fff;
  text-align: center;
  width: 100%;
  font-size: 18px;
}

.boxWrapperBig {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapperBig {
  // width: 300px;
  text-align: center;
}

* {
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  height: 100%;
}

.webPages {
  background: #fff;
}

.headerBox {
  position: fixed;
  width: 100%;
  z-index: 4;
  background: #fff;
  border-bottom: 1px solid #fcfcfc;
}

.bigBgBox {
  position: relative;

}

.leftBox {
  width: 30%;
  position: absolute;
  left: 15%;
  top: 30%;
  z-index: 2;
}

.rightBox {
  width: 70%;
  margin-left: 30%;
  position: relative;
}

.bigSpan {
  position: absolute;
  bottom: 5%;
  color: #fff;
  font-size: 45px;
  width: 80%;
  text-align: center;
  left: 10%;
}

@media screen and (max-width: 1680px) and (min-width: 1450px) {
  .bigSpan {
    font-size: 35px;
  }

  .wechat-qr:before {
    top: 100px;
  }

  .wechat-dw:before {
    top: 123px;
  }
}

.imgTxtLeft {
  width: 50%;
}

.imgTxtRight {
  width: 50%;
  margin-left: 50%;
  height: 60px;
}

.titleBox {
  margin-top: 10%;
  text-align: center;
}

.bigTitle {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 5px;
}

.titleTips {
  font-size: 12px;
  margin-top: 10px;
}

.videoBox {
  width: 80%;
  margin: auto;
  overflow: hidden;
  height: 600px;
  // position: relative;
  margin-top: 40px;
}

// 一个视频的时候
.oneVideoBox {
  width: 800px;
  margin: auto;
  margin-top: 40px;
  position: relative;
  height: 480px;
}

/deep/ .oneVideoPlay>.video-js {
  z-index: 2 !important;
}

.borderBox {
  position: absolute;
  border: 5px solid #000;
  width: 600px;
  height: 460px;
  right: -40px;
  top: 50px;
}

.nextPreBtn {
  display: flex;
  width: 200px;
  margin: auto;
  margin-bottom: 20px;
  margin-top: 50px;
}

.nextPreBtn .preBtn,
.nextPreBtn .nextBtn {
  border: 1px solid #555;
  cursor: pointer;
  width: 20%;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nextPreBtn .preBtn {
  margin-right: 60%;
  width: 35px;
  height: 35px;
}

.nextPreBtn .nextBtn {
  width: 35px;
  height: 35px;
}

.nextPreBtn .preBtn:hover,
.nextPreBtn .nextBtn:hover {
  opacity: 0.8;
}

.videoBox::-webkit-scrollbar {
  width: 0 !important;
}

.videoBox::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.scollBox {
  height: 600px;
  float: left;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.videoPlayOne {
  width: 380px;
  float: left;
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
}

.remakeImgBox {
  position: absolute;
  z-index: 4;
  width: 342px;
  height: 200px;
  left: 19px;
  cursor: pointer;
}

.videoPlayOne:hover {
  opacity: 0.8;
}

.videoImg {
  width: 90%;
  background: rgba(0, 0, 0, 0.5);
  height: 200px;
  margin: auto;
  cursor: pointer;
  position: relative;
  z-index: 3;
}

.videoImg .van-icon {
  color: #ccc;
  font-size: 50px;
  margin-top: 22%;
}

.videoName {
  font-weight: bold;
  margin-top: 15px;
  font-size: 18px;
}

.videoTips {
  margin-top: 5px;
  font-size: 15px;
  color: #666;
}

.planBox {
  position: relative;
}

.planLeft {
  position: absolute;
  left: 10%;
  top: 15%;
  width: 40%;
}

.planRight {
  height: 800px;
  width: 60%;
  background: #fff;
  margin-left: 40%;
}

.testBtn {
  width: 8%;
  background: #58aae4;
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
  position: absolute;
  margin-left: 45%;
  top: 90%;
  cursor: pointer;
}

.testBtn:hover {
  opacity: 0.8;
}

.fansBgBox {
  background-image: url("../assets/bg2.png");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.fansAppBigImg {
  width: 500px;
  position: absolute;
  top: 35%;
  left: 10%;
}

.fansImg {
  width: 50px;
  background: #000;
  height: 50px;
  border-radius: 50%;
  // float: left;
  margin-right: 15px;
  overflow: hidden;
}

.fansBoxTop {
  display: flex;
}

.fansListBox {
  display: flex;
  width: 80%;
  margin: auto;
  margin-top: 15%;
  height: 400px;
}

.listFlex {
  margin-right: 10%;
  width: 50%;
}

.leftFansBox {
  width: 45%;
}

.rightFansBox {
  width: 55%;
}

.fansTxtOne {
  font-size: 80px;
  font-weight: bold;
}

.fansTxtTwo {
  font-size: 40px;
}

.fansTxtThree {
  font-size: 20px;
  margin-top: 40px;
}

.fansTxt {
  margin-left: 30%;
  margin-top: 10%;
}

.fansOne {
  height: 80px;
}

.fansBoxBottom {
  background: rgba(0, 0, 0, 0.3);
}

.codeDownBox {
  width: 50%;
  margin-left: 50%;
  display: flex;
  height: 250px;
  margin-top: 150px;
  align-items: center;
}

.codeDownBox .downAppCode {
  width: 150px;
  height: 150px;
}

.downAppImg {
  width: 200px;
  margin-left: 10%;
  cursor: pointer;
  position: relative;
}

.downAppTips {
  text-align: center;
  color: #fff;
  letter-spacing: 5px;
  margin-top: 15px;
}

.downAppBtn {
  display: flex;
}

.downAppBox {
  margin-left: 10%;
  width: 70%;
}

.downTips {
  text-align: center;
  color: #fff;
  margin-top: 20px;
}

.communityTitle {
  text-align: center;
  margin-top: 50px;
  font-size: 25px;
}

.commMsgBox {
  width: 60%;
  margin: auto;
  height: 500px;
  position: relative;
}

.commMsgOne {
  border: 1px solid #ccc;
  -webkit-box-shadow: 0px 4px 1px #fcfcfc;
  box-shadow: 0px 4px 1px #fcfcfc;
  border-radius: 5px;
  padding: 5px 15px 5px 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
  position: absolute;
  background: #fff;
  height: 20px;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
}

.commMsgOne:hover {
  background: #fcfcfc;
  padding: 8px;
  z-index: 9;
}

.grayCircle {
  background: gray;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 6px;
  margin-left: 5px;
  margin-right: 5px;
}

.holdMsgBtn {
  background: #d23030;
  color: #fff;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0px 5px 0 #ccc;
  cursor: pointer;
  margin: auto;
}

.holdMsgBtn:hover {
  opacity: 0.8;
}

.partnerTitle {
  text-align: center;
  font-size: 25px;
  margin-top: 50px;
}

.partnerImg {
  width: 60%;
  margin: auto;
  height: 200px;
  margin-top: 100px;
}

.itemTabBox {
  display: flex;
  width: 60%;
  margin: auto;
  margin-top: 100px;
}

.itemTab {
  width: 50%;
}

.itemFlex {
  display: flex;
  height: 50px;
  line-height: 50px;
}

.itemImgBox {
  display: flex;
  width: 50%;
  align-items: center;
}

.itemImgIcon {
  width: 50px;
  margin: auto;
  cursor: pointer;
  position: relative;
}

div.itemImgIcon:hover .wechat-qr {
  display: block;
}

div.downAppImg:hover .wechat-dw {
  display: block;
}

.itemTabName {
  width: 33.33%;
}

.itemTabName a {
  color: #000;
  font-weight: bold;
}

.itemImg {
  width: 33.33%;
  text-align: center;
}

.itemImgTxt {
  margin-top: 10px;
  font-size: 12px;
}

.footerTipsBox {
  width: 55%;
  float: left;
  margin-right: -35%;
  margin-left: 10%;
}

.footerImg {
  width: 130px;
  margin-right: 20%;
  border-radius: 5px;
  overflow: hidden;
  height: 42px;
  // background:red
}

.footerBox {
  background: #353535;
  padding: 50px 0;
  margin-top: 100px;
}

.footerContent {
  color: #fff;
  width: 95%;
  margin: auto;
  position: relative;
  font-size: 14px;
  margin-right: 20%;
}

.footerTips {
  margin-top: 20px;
}

.footerTips a {
  color: #fff;
}

.imgTxtLeft.moveToRight {
  -webkit-animation-name: moveToRight;
  -moz-animation-name: moveToRight;
  -o-animation-name: moveToRight;
  animation-name: moveToRight;
  -webkit-animation-duration: 1000ms;
  -moz-animation-duration: 1000ms;
  -o-animation-duration: 1000ms;
  animation-duration: 1000ms;
}

.imgTxtRight.moveToLeft {
  -webkit-animation-name: moveToLeft;
  -moz-animation-name: moveToLeft;
  -o-animation-name: moveToLeft;
  animation-name: moveToLeft;
  -webkit-animation-duration: 1000ms;
  -moz-animation-duration: 1000ms;
  -o-animation-duration: 1000ms;
  animation-duration: 1000ms;
}

// 动画

@keyframes moveToRight {
  0% {
    margin-left: -50%;
    opacity: 0.3;
  }

  100% {
    margin-left: 0%;
    opacity: 1;
  }
}

@keyframes moveToLeft {
  0% {
    margin-left: 100%;
    opacity: 0.3;
  }

  100% {
    margin-left: 50%;
    opacity: 1;
  }
}

// 视频
.videoFloat {
  position: fixed;
  width: 50%;
  top: 22%;
  left: 25%;
  z-index: 5;
}

.videoBgBox {
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 4;
}

.closeVideo {
  color: #555;
  font-size: 1rem;
  top: 10%;
  left: 50%;
  position: absolute;
  background: #fff;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 15px;
  cursor: pointer;
}

.certificate {
  display: flex;
  margin: auto;
}

.certificateImg {
  flex: 1;
  height: 150px;
  text-align: center;
}

.boxImgCert {
  width: 50%;
  height: 100px;
  margin: auto;
  margin-bottom: 5px;
}

.certificateImg span {
  font-size: 8px;
}

.footerImgBox {
  display: flex;
  margin-left: 35%;
  margin-top: 30px;
}

/deep/ .oneVideoType {
  width: 10%;
  top: 40%;
  left: 45%;
  border: none;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

// 单个视频
.videoBoxShow {
  // width: 90%;
  width: 100%;
  margin: auto;
  margin-top: 1rem;
  border: 2px solid #fff;
  box-shadow: 0 2px 64px 0 rgba(0, 0, 0, 0.12);
  background: #fff;
  position: relative;
  height: 480px;
}

#videoOne {
  position: absolute;
  top: 0;
  z-index: 1;
  height: 480px;
  width: 100%;
  background: #fff;
}

#videoOneCover {
  position: absolute;
  z-index: 3;
  top: 0px;
  background: #fff;
}

#pauseVideo {
  background: rgba(220, 223, 226, 0.75);
  position: absolute;
  top: 40%;
  width: 10%;
  height: 2rem;
  z-index: 3;
  left: 45%;
  border-radius: 50%;
}

#videoBtnPlay {
  background: rgba(185, 185, 185, 0.75);
  position: absolute;
  top: 40%;
  width: 60px;
  height: 60px;
  z-index: 3;
  left: 48%;
  border-radius: 50%;
  cursor: pointer;
}

#videoBtnPlay>.img {
  background: rgba(232, 232, 232, 0.75);
}

.wechat-dw {
  top: -153px;
}

.moreVid {
  width: 150px;
  text-align: center;
  margin: auto;
  border: 1px solid #ccc;
  height: 35px;
  line-height: 35px;
  border-radius: 35px;
  cursor: pointer;
  margin-top: 30px;
  position: relative;
}

.moreVid:hover .showMoreCord {
  display: block;
}

.showMoreCord {
  position: absolute;
  top: -170px;
  display: block;
  z-index: 999;
  box-shadow: 0 0 10px 1px #d6d6d6;
  background: #fff;
  display: none;
  width: 80%;
  left: 10%;
}

.codeTxt {
  font-size: 12px;
  margin-top: -10px;
}

/* 适配----------------------------------------------------------------------------------------------------------------------------------------------------------------- */
@media screen and (max-width: 1439px) and (min-width: 1024px) {
  .bigSpan {
    font-size: 30px;
  }

  .navTitle {
    font-size: 16px;
    width: 13%;
  }

  .videoBox {
    width: 90%;
  }

  .logoBox {
    width: 140px;
    height: 50px;
  }

  .imgTxtRight {
    height: 40px;
  }

  .bigTitle {
    font-size: 20px;
  }

  .titleTips {
    font-size: 10px;
  }

  .nextPreBtn .preBtn,
  .nextPreBtn .nextBtn {
    height: 18px;
    width: 18px;
  }

  .nextPreBtn {
    margin-top: 20px;
  }

  .planLeft {
    width: 40%;
    height: 65%;
  }

  .planRight {
    height: 500px;
  }

  .testBtn {
    width: 8%;
    background: #58aae4;
    color: #fff;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 5px;
    position: absolute;
    margin-left: 45%;
    top: 85%;
    cursor: pointer;
    font-size: 12px;
  }

  .fansTxtOne {
    font-size: 50px;
  }

  .fansTxtTwo {
    font-size: 25px;
  }

  .fansTxtThree {
    font-size: 15px;
  }

  .fansAppBigImg {
    width: 400px;
    position: absolute;
    top: 32%;
    left: 6%;
  }

  .downAppImg {
    width: 100px;
  }

  .codeDownBox {
    margin-top: 0;
    height: 150px;
  }

  .codeDownBox .downAppCode {
    width: 80px;
    height: 80px;
  }

  .downAppTips {
    text-align: center;
    color: #fff;
    margin-top: 5px;
    font-size: 10px;
    letter-spacing: 2px;
  }

  .downTips {
    text-align: center;
    color: #fff;
    margin-top: 5px;
    font-size: 10px;
  }

  .communityTitle {
    margin-top: 20px;
    font-size: 12px;
  }

  .partnerTitle {
    font-size: 15px;
  }

  .partnerImg {
    width: 60%;
    margin: auto;
    height: 100px;
    margin-top: 50px;
  }

  .itemFlex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
  }

  .itemImgIcon {
    width: 30px;
  }

  .itemImgTxt {
    font-size: 8px;
    margin-top: 0;
  }

  .wechat-qr {
    top: -110px;
  }

  .wechat-dw {
    top: -140px;
  }

  .wechat-qr:before {
    top: 90px;
  }

  .wechat-dw:before {
    top: 110px;
  }

  .footerContent {
    font-size: 13px;
  }

  .footerTips {
    margin-top: 15px;
  }

  .footerTips span {
    font-size: 18px;
  }

  .footerBox {
    padding: 10px;
  }

  .footerImg {
    // width: 130px;
    // margin-right: 20%;
    // border-radius: 5px;
    // overflow: hidden;
    // height: 45px;
  }

  .footerImgBox {
    // top: 15%;
    margin-left: 35%;
  }

  .certificate {
    padding-top: 35px;
  }

  .footerImgBox {
    margin-top: 0;
  }

  .fansImg {
    width: 30px;
    height: 30px;
  }

  .fansName {
    font-size: 10px;
  }

  .fansTips {
    font-size: 10px;
  }

  .oneVideoBox {
    width: 800px;
    margin: auto;
    margin-top: 40px;
    position: relative;
  }

  .borderBox {
    height: 460px;
  }

  .footerTipsBox {
    width: 55%;
    margin-top: 35px;
    margin-right: -35%;
  }
}

@media screen and (max-width: 1023px) and (min-width: 768px) {
  .navTitle {
    font-size: 16px;
    width: 14%;
  }

  .logoBox {
    width: 140px;
    height: 50px;
    margin-top: 15px;
  }

  .imgTxtRight {
    height: 40px;
  }

  .bigTitle {
    font-size: 16px;
  }

  .titleTips {
    font-size: 12px;
  }

  .nextPreBtn .preBtn,
  .nextPreBtn .nextBtn {
    height: 18px;
    width: 18px;
  }

  .nextPreBtn {
    margin-top: 20px;
  }

  .planLeft {
    width: 40%;
    height: 65%;
  }

  .planRight {
    height: 400px;
  }

  .testBtn {
    width: 8%;
    background: #58aae4;
    color: #fff;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 5px;
    position: absolute;
    margin-left: 45%;
    top: 85%;
    cursor: pointer;
    font-size: 12px;
  }

  .fansTxtOne {
    font-size: 50px;
  }

  .fansTxtTwo {
    font-size: 25px;
  }

  .fansTxtThree {
    font-size: 15px;
  }

  .fansAppBigImg {
    width: 400px;
    position: absolute;
    top: 32%;
    left: 6%;
  }

  .downAppImg {
    width: 100px;
  }

  .codeDownBox {
    margin-top: 0;
    height: 150px;
  }

  .codeDownBox .downAppCode {
    width: 80px;
    height: 80px;
  }

  .downAppTips {
    text-align: center;
    color: #fff;
    margin-top: 5px;
    font-size: 10px;
    letter-spacing: 2px;
  }

  .downTips {
    text-align: center;
    color: #fff;
    margin-top: 5px;
    font-size: 10px;
  }

  .communityTitle {
    margin-top: 20px;
    font-size: 12px;
  }

  .partnerTitle {
    font-size: 15px;
  }

  .partnerImg {
    width: 60%;
    margin: auto;
    height: 100px;
    margin-top: 50px;
  }

  .itemFlex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 30px;
    line-height: 30px;
    font-size: 10px;
  }

  .itemImgIcon {
    width: 30px;
  }

  .itemImgTxt {
    font-size: 8px;
    margin-top: 0;
  }

  .wechat-qr {
    top: -110px;
  }

  .wechat-dw {
    top: -110px;
  }

  .wechat-qr:before {
    top: 90px;
  }

  .wechat-dw:before {
    top: 100px;
  }

  .footerContent {
    font-size: 12px;
  }

  .footerTips {
    margin-top: 15px;
  }

  .footerTips span {
    font-size: 18px;
  }

  .footerBox {
    padding: 10px;
  }

  .footerImg {
    // width: 130px;
    // margin-right: 20%;
    // border-radius: 5px;
    // overflow: hidden;
    // height: 45px;
  }

  .boxImgCert {
    height: 60px;
  }

  .footerImgBox {
    top: 15%;
  }

  .certificate {
    padding-top: 15px;
  }

  .bigCodeShow {
    width: 200px;
  }

  .bigCodeShow span {
    color: #fff;
    text-align: center;
    width: 100%;
    font-size: 12px;
  }

  .fansImg {
    width: 30px;
    height: 30px;
  }

  .fansName {
    font-size: 10px;
  }

  .fansTips {
    font-size: 10px;
  }

  .oneVideoBox {
    width: 800px;
    margin: auto;
    margin-top: 40px;
    position: relative;
  }

  .footerTipsBox {
    margin-right: -20%;
  }
}
</style>
<style>
.video-js .vjs-big-play-button {
  width: 20%;
  top: 40%;
  left: 40%;
  border: none;
  background-color: #000;
  border-radius: 0;
}

.video-js {
  background-color: #000 !important;
}

/* 微信二维码 */
.wechat-qr {
  display: none;
  position: absolute;
  z-index: 100;
  left: 50%;
  margin-left: -75px;
  top: -123px;
  border: 1px solid #584f60;
}

.wechat-qr:before {
  top: 100px;
  left: 69px;
  background: #fff;
  content: "\0020";
  height: 8px;
  width: 8px;
  position: absolute;
  pointer-events: none;
  border-color: #fff;
  border-left: 1px solid #584f60;
  border-bottom: 1px solid #584f60;
  transform: rotate(-45deg);
}

/* 下载二维码 */
.wechat-dw {
  display: none;
  position: absolute;
  z-index: 100;
  left: 50%;
  margin-left: -65px;
  top: -123px;
  /* border: 1px solid #584f60; */
}

.wechat-dw:before {
  top: 138px;
  left: 69px;
  background: #fff;
  content: "\0020";
  height: 8px;
  width: 8px;
  position: absolute;
  pointer-events: none;
  border-color: #fff;
  border-left: 1px solid #584f60;
  border-bottom: 1px solid #584f60;
  transform: rotate(-45deg);
}

/* 过度 */
.fades-enter-active,
.fades-leave-active {
  transition-property: opacity, left;
  transition-duration: 1s, 1s;
}

/* 动画开始 */
.fades-enter,
.fades-leave-to {
  opacity: 0;
  left: -50px;
}

/* 动画结束 */
.fades-leave,
.fades-enter-to {
  opacity: 1;
  left: 0px;
}

/* 新 */
.collegeBox {
  width: 1140px;
  margin: auto;
  margin-top: 50px;
  cursor: grab;
  height: 480px;
  overflow: hidden;
  /* 超出内容不可见 */
}

.remakeImgBox.newBox {
  box-shadow: 1px 4px 8px 1px #ccc;
}

.newBox:hover {
  background: rgba(0, 0, 0, 0.5);
  opacity: 0.1;
  transition: 0.5s;
}

.videoImg.newBox {
  background: rgba(0, 0, 0);
}

.videoTitle {
  position: absolute;
  bottom: 15px;
  color: #fff;
  font-size: 16px;
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/web/index.vue